<template>
  <div>
    <Breadcrumbs main="Home" title="Submission"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">

          <div class="col-xl-8">
            <b-card header-tag="div" no-body>

              <b-card-body>
                <b-tabs pills slot="header" class="tabbed-card">
                  <b-tab title="Primary Info" :active="active1">
                    <form>
                      <div class="row">
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Name of Team / Innovation (if any) </label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="Team ONE"
                                  v-model="data.team_name"
                              />
                            </div>

                          </div>
                        </div>

                        <div class="col-md-12">
                          <label class="col-form-label pt-5">Name of Applicant / Team Leader
                            (As per NID/Birth Certificate/Passport) </label>
                          <div class="form-row">
                            <div class="col-6">
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="First name"
                                  v-model="data.description.first_name"

                              />
                            </div>
                            <div class="col-6">
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="Last name"
                                  v-model="data.description.last_name"
                              />
                            </div>
                          </div>
                        </div>


                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Primary Email Address</label>
                              <input
                                  class="form-control"
                                  type="email"
                                  required=""
                                  placeholder="Test@gmail.com"
                                  v-model="data.description.primary_email"
                              />
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-5">Highest Academic Qualification Completed</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="e.g., HSC, BBA in Marketing, MSc in Environmental Science"
                                  v-model="data.description.highest_education"

                              />
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Gender</label>
                              <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio3" value="Male" v-model="data.description.gender">Male</b-form-radio>
                                </div>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio3" value="Female" v-model="data.description.gender">Female</b-form-radio>
                                </div>
                                <br>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio3" value="Non-binary" v-model="data.description.gender">Non-binary</b-form-radio>
                                </div>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio3" value="Prefer not to say " v-model="data.description.gender">Prefer not to say </b-form-radio>
                                </div>
                              </div>
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-5">Date of Birth</label>
                              <div class="col-6">
                                <datepicker input-class="datepicker-here form-control digits" :format="format" v-model="data.description.date_of_birth" ></datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">NID / Student ID / Other Valid ID Number </label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="6411xxxxxx"
                                  v-model="data.description.id_number"

                              />
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-5">Mobile Number (WhatsApp Enabled) </label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="01xxxxxxxxxx"
                                  v-model="data.description.whatsapp_no"

                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Current Address (District, Upazila) </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Banani, Dhaka" v-model="data.description.current_address"></textarea>
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-5">Permanent Address (if different) </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Banani, Dhaka" v-model="data.description.permanent_address"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Are you applying as a:</label>
                              <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio4" :value="true" v-model="data.description.team">Team</b-form-radio>
                                </div>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio4" :value="false" v-model="data.description.team">Individual</b-form-radio>
                                </div>

                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="col-md-12"  v-if="data.description.team">
                          <label class="col-form-label pt-5">Member 1 </label>
                          <div class="form-row">
                            <div class="col-6">
                             <label class="col-form-label pt-2">Full Name</label>
                              <input
                                  class="form-control"
                                  type="text"

                                  placeholder="Full Name"
                                  v-model="data.description.members.member_1.name"

                              />
                            </div>
                            <div class="col-6">
                             <label class="col-form-label pt-2">Email</label>
                              <input
                                  class="form-control"
                                  type="text"

                                  placeholder="email@gmail.com"
                                  v-model="data.description.members.member_1.email"
                              />
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-2">Highest Education</label>
                              <input
                                  class="form-control"
                                  type="text"

                                  placeholder="HSC"
                                  v-model="data.description.members.member_1.highest_education"
                              />
                            </div>
                          </div>

                          <label class="col-form-label pt-5">Member 2 </label>
                          <div class="form-row">
                            <div class="col-6">
                             <label class="col-form-label pt-2">Full Name</label>
                              <input
                                  class="form-control"
                                  type="text"

                                  placeholder="Full Name"
                                  v-model="data.description.members.member_2.name"

                              />
                            </div>
                            <div class="col-6">
                             <label class="col-form-label pt-2">Email</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  placeholder="email@gmail.com"
                                  v-model="data.description.members.member_2.email"
                              />
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-2">Highest Education</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  placeholder="HSC"
                                  v-model="data.description.members.member_2.highest_education"
                              />
                            </div>
                          </div>

                          <label class="col-form-label pt-5">Member 3 </label>
                          <div class="form-row">
                            <div class="col-6">
                             <label class="col-form-label pt-2">Full Name</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  placeholder="Full Name"
                                  v-model="data.description.members.member_3.name"

                              />
                            </div>
                            <div class="col-6">
                             <label class="col-form-label pt-2">Email</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  placeholder="email@gmail.com"
                                  v-model="data.description.members.member_3.email"
                              />
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-2">Highest Education</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  placeholder="HSC"
                                  v-model="data.description.members.member_3.highest_education"
                              />
                            </div>
                          </div>
                        </div>






                        <div class="col-md-4 pt-5">
                          <button class="btn btn-primary" type="submit" @click.prevent="submitProposal(1)">Next</button>
                        </div>
                      </div>
                    </form>
                  </b-tab>
                  <b-tab title="Idea" :disabled="stage>=1" :active="active2">
                    <form>
                      <div class="row">
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Title of Your Idea / Innovation  </label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="Team ONE"
                                  v-model="data.description.idea.title"
                              />
                            </div>

                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">Brief Description of Your Idea (Max 150 words)
                              </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Details in brief" v-model="data.description.idea.brief_description"></textarea>
                            </div>

                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Problem Statement (Max 100 words)
                              </label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="Team ONE"
                                  v-model="data.description.idea.problem_statement"
                              />
                            </div>

                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">Proposed Solution (Max 150 words)

                              </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Details in brief" v-model="data.description.idea.proposed_solution"></textarea>
                            </div>

                          </div>
                        </div>

                        <div class="col-md-12">
                          <label class="col-form-label pt-5">How does your idea relate to the following areas?
                            (Check all that apply)
                          </label>
                          <div class="form-check" v-for="option in areaOptions" :key="option">
                            <input class="form-check-input"
                                   type="checkbox"
                                   :value="option"
                                   v-model="data.description.idea.area">
                            <label class="form-check-label">{{ option }}</label>
                        </div>
                        </div>
                        <div class="col-md-12">
                          <label class="col-form-label pt-5">Implementation Area (Where will this idea be piloted?)
                          </label>
                          <div class="form-check" v-for="option in implementationAreaOptions" :key="option">
                            <input class="form-check-input"
                                   type="checkbox"
                                   :value="option"
                                   v-model="data.description.idea.implementation_area">
                            <label class="form-check-label">{{ option }}</label>
                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">Target Beneficiaries
                                Who will benefit from your solution? (e.g., households, waste workers, students)

                              </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Details in brief" v-model="data.description.idea.target_beneficiaries"></textarea>
                            </div>

                          </div>
                        </div>

                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-5">Do you already have a prototype or concept model</label>
                              <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio5" :value="true" v-model="data.description.idea.prototype">Yes</b-form-radio>
                                </div>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio5" :value="false" v-model="data.description.idea.prototype">No</b-form-radio>
                                </div>
                                <br>
                              </div>
                            </div>
                            <div class="col-6">
                              <label class="col-form-label pt-5">Has this idea been implemented or tested before</label>
                              <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio6" :value="true" v-model="data.description.idea.already_implemented">Yes</b-form-radio>
                                </div>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio6" :value="false" v-model="data.description.idea.already_implemented">No</b-form-radio>
                                </div>
                                <br>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="col-md-12" v-if="data.description.idea.already_implemented">

                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">If yes, please describe where and what was the result (Max 100 words)  </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Banani, Dhaka" v-model="data.description.idea.existence"></textarea>
                            </div>

                          </div>
                        </div>






                        <div class="col-md-4 pt-5">
                          <button class="btn btn-primary" type="submit" @click.prevent="submitProposal(2)">Next</button>
                        </div>
                      </div>
                    </form>
                  </b-tab>
                  <b-tab title="Sustainability" :disabled="stage>1" :active="active3">
                    <form>
                      <div class="row">
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">How do you plan to sustain this idea as a business?
                                Revenue model, cost structure, and scalability (Max 200 words)
                              </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Details in brief" v-model="data.description.sustainability.plan"></textarea>

                            </div>

                          </div>
                        </div>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">Do you currently have any funding or investment?
                              </label>
                              <div class="form-group m-checkbox-inline mb-0 custom-radio-ml">
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio8" :value="true" v-model="data.description.sustainability.funding">Yes</b-form-radio>
                                </div>
                                <div class="radio radio-primary d-inline-block">
                                  <b-form-radio name="radio8" :value="false" v-model="data.description.sustainability.funding">No</b-form-radio>
                                </div>
                                <br>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-row">
                            <div class="col-12">
                              <label class="col-form-label pt-5">If yes, from whom?
                              </label>
                              <textarea class="form-control" rows="5"
                                        placeholder="Details in brief" v-model="data.description.sustainability.funding_details"></textarea>

                            </div>

                          </div>
                        </div>
                        <div class="col-md-12">
                          <label class="col-form-label pt-5">What kind of support do you need?</label>
                          <div class="form-check" v-for="option in supportOptions" :key="option">
                            <input class="form-check-input"
                                   type="checkbox"
                                   :value="option"
                                   v-model="data.description.sustainability.support">
                            <label class="form-check-label">{{ option }}</label>
                          </div>

                        </div>
                        <span class="pt-5">Declaration
I certify that the information provided in this form is true and original. I understand that my idea, if selected, will be used solely for the purposes of the NextGen Water and Waste Innovation Challenge, and I will retain ownership unless otherwise agreed in writing. </span>
                        <div class="col-md-12">

                          <div class="form-row">
                            <div class="col-6">
                              <label class="col-form-label pt-2">Signature</label>
                              <input
                                  class="form-control"
                                  type="text"
                                  required=""
                                  placeholder="Samiur Rahman"
                                  v-model="data.description.signature"
                              />
                            </div>

                          </div>
                        </div>

                        <span class="pt-5">
                          By Clicking Submit, I allow Catch Bangladesh, WaterAid, and Swisscontact to use my idea summary, name, and photos/videos (if selected) for campaign, documentation, or promotional purposes.
                        </span>





                        <div class="col-md-4 pt-5">
                          <button class="btn btn-primary" type="submit" @click.prevent="submitProposal(3)">Final Submit</button>
                        </div>
                      </div>
                    </form>
                  </b-tab>
                </b-tabs>
              </b-card-body>
              <h5 slot="header"></h5>
            </b-card>

          </div>
          <div class="col-xl-4">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title mb-0"> Information</h4>
              </div>
              <div class="card-body">
                After Submitting the proposal, Ensure to Upload Attachments related to the proporal.
                <br>Reviewers will judge based on the supporting documents.
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';

  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';
  import responses from '@/pages/article19/application_form/responses.vue';
  import {mapState} from "vuex";
  import {host} from "@/_helpers/APIPath";
  export default {
    components: {
      Datepicker
    },
    data() {
      return {
        host:host,
        submission_attachment:null,
        link:null,
        title:null,
        active1:true,
        active2:false,
        active3:false,
        format: 'MM/dd/yyyy',
        data:{
          user:null,
          stage:1,
          'description':{
            'first_name':null,
            'last_name':null,
            'date_of_birth':null,
            'gender':null,
            'id_number':null,
            'primary_email':null,
            'whatsapp_no':null,
            'current_address':null,
            'permanent_address':null,
            'highest_education':null,
            'team':false,
            'members':{
              member_1:{
                name:null,
                email:null,
                highest_education:null
              },
              member_2:{
                name:null,
                email:null,
                highest_education:null
              },member_3:{
                name:null,
                email:null,
                highest_education:null
              }

            },
            'idea': {
              'title': null,
              'brief_description': null,
              'problem_statement': null,
              'proposed_solution': null,
              'area': [],
              'implementation_area': [],
              'target_beneficiaries': null,
              'prototype': null,
              'already_implemented': null,
              'existence': null
            },
            "sustainability":{
              "plan":null,
              "funding":false,
              "funding_details":null,
              "support":[]
            },
            "signature":null,

          },
          'team_name':null,
          'status':'Incomplete'
        },
        numberSelectedFlatInput: 1,
        numberOptions: [
          { value: 1, text: 1 },
          { value: 2, text: 2 },
          { value: 3, text: 3 },
          { value: 4, text: 4 },
          { value: 5, text: 5 }
        ],
        supportOptions: [
          "Business Mentorship",
          "Seed Funding",
          "Technical Mentorship (WASH/Engineering)",
          "Legal or Policy Guidance",
          "Networking & Partnerships",
          "Branding & Communication",
          "Community Testing Opportunity"
        ],
        implementationAreaOptions: [
          "Satkhira Paurashava",
          "Shyamnagar",
          "Assasuni",
          "Dhamoirhat Paurashava",
          "Niamatpur"
        ],
        areaOptions: [
          "Solid Waste Management",
          "Integrated Water Resource Management",
          "Climate Resilience",
          "Public Service Innovation",
          "Youth Engagement",
          "Digital or Tech-based Solution"
        ],
        smsCount: ''
      };
    },

    created() {
      if(this.$route.params.id!=0){
        this.$store.dispatch('submission/fetchSubmissionDetail',this.$route.params.id).then(response=>{
          console.log(response.data.user.id);
          this.data.description= response.data.description;
          this.data.user=response.data.user.id;
          console.log(response.data.description.idea);
          if(!response.data.description.idea) {
            this.data.description.idea ={
              'title': null,
              'brief_description': null,
              'problem_statement': null,
              'proposed_solution': null,
              'area': [],
              'implementation_area': [],
              'target_beneficiaries': null,
              'prototype': null,
              'already_implemented': null,
              'existence': null
            };
          }if(!response.data.description.sustainability) {
            this.data.description.sustainability ={
              "plan":null,
              "funding":null,
              "funding_details":null,
              "support":[]
            }
          }
          this.data.stage = response.data.stage;
          this.data.team_name = response.data.team_name;
          console.log(this.data.stage);
          if(this.data.stage==1){
            this.active2=true;
            this.active3=false;
          }else if(this.data.stage==2){
            this.active3=true;
          }
        });
      }
    },
    methods: {
      getCharacterCount() {
        return this.smsCount.length;
      },
      createFunc(){
        this.$store.dispatch('submission/adminCreateSubmission', this.data).then(response => {
          if (response.code == 201) {
            this.active1 = false;
            this.active2 = true;
            this.active3 = false;
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });
            this.$router.push('/admin/submission-create/'+response.data.id);


            setTimeout(() => {
              // this.$router.push('/admin/fellowship');
            }, 2000);

          } else {
            this.isDisabled = false;
            Swal.fire({
              title: 'Error!',
              text: JSON.stringify(response.message),
              icon: 'error'
            });
          }

        });
      },
      updateFunc(){
        console.log(this.data.stage)
        if(this.data.stage==3){
          this.data.status='Pending';
        }
        this.$store.dispatch('submission/AdminUpdateSubmission', this.data).then(response => {
          console.log(response);
          if (response.code == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });
            this.data.description=response.data.description;
            this.data.team_name=response.data.team_name;
            this.data.stage=response.data.stage;
            this.data.user=response.data.user;

            if(this.data.stage==1){
              this.active2=true;
              this.active3=false;
              this.active1=false
            }else if(this.data.stage==2){
              this.active2=false;
              this.active3=true;
              this.active1=false
            }
            console.log(this.data.stage==3)
            if(this.data.stage==3){
              this.$router.push('/admin/submission-detail/'+response.data.id);
            }

            setTimeout(() => {

            }, 2000);

          } else {
            this.isDisabled = false;
            Swal.fire({
              title: 'Error!',
              text: JSON.stringify(response.message),
              icon: 'error'
            });
          }

        });
      },
      submitProposal(stage){

        this.data.stage=stage;


        console.log(typeof(this.$route.params.id));
        if(this.$route.params.id==0){
          this.createFunc();
        }else{
          this.updateFunc();
        }
        console.log(this.data);

      }
    }
  };
</script>
